module.exports = "/build/web/svg/icon-phone.0826d277ce0d738767b82e82197a516c.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-phone.svg
// module id = 127
// module chunks = 13